exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-loading span[data-v-41e9eba6]::after {\n  top: 0;\n  right: 0;\n}\n", ""]);

// exports
